import { PAGE_VIEW } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { useEditorActions } from '../../hooks/useEditorActions';
import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import { usePageViewFilter } from '../../hooks/usePageViewFilter';
import ConditionError from '../common/ConditionError';
import EditorConditionInputs from './EditorConditionInputs';
import EditorConditionRefinements from './EditorConditionRefinements';
import EditorRelatedConditionsGroupContainer from './EditorRelatedConditionsGroupContainer';
import EditorRelatedConditionsRefineButton from './EditorRelatedConditionsRefineButton';
import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import EditorConditionRefinementsContainer from './EditorConditionRefinementsContainer';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorPageViewRelatedConditionsGroup = props => {
  const {
    condition,
    conditionPath,
    dataSeleniumInfo,
    inputUse
  } = props;
  const {
    onRefineFilter,
    onConditionDelete
  } = useEditorActions();
  const {
    onFieldConditionValueChange,
    onFieldConditionOperatorChange
  } = useFieldConditionChange(PAGE_VIEW, conditionPath, condition);
  const {
    statusCondition,
    dateRefinementCondition,
    numberRefinementCondition,
    refinementConditionsEmptyValue,
    onStatusChange
  } = usePageViewFilter(condition, onFieldConditionValueChange);
  const {
    props: {
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const hasInPlaceRefinementSelection = !!useOnePanel;
  const heading = /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(EditorConditionInputs, {
      inputUse: inputUse,
      condition: statusCondition,
      dataSeleniumInfo: dataSeleniumInfo,
      filterFamily: PAGE_VIEW,
      onConditionOperatorChange: onFieldConditionOperatorChange,
      onConditionValueChange: onStatusChange
    }), /*#__PURE__*/_jsx(ConditionError, {
      condition: condition
    }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
      condition: condition
    }), !hasInPlaceRefinementSelection && /*#__PURE__*/_jsx(EditorRelatedConditionsRefineButton, {
      dataSeleniumInfo: dataSeleniumInfo,
      onClick: () => onRefineFilter(PAGE_VIEW, conditionPath)
    }), hasInPlaceRefinementSelection && /*#__PURE__*/_jsx(EditorConditionRefinementsContainer, {
      inputUse: inputUse,
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: PAGE_VIEW,
      onConditionChange: onFieldConditionValueChange,
      emptyRefinementConditions: refinementConditionsEmptyValue
    })]
  });
  return hasInPlaceRefinementSelection ? /*#__PURE__*/_jsx(EditorRelatedConditionsGroupContainer, {
    condition: condition,
    dataSeleniumInfo: dataSeleniumInfo,
    heading: heading,
    onGroupDelete: () => onConditionDelete(conditionPath)
  }) : /*#__PURE__*/_jsx(EditorRelatedConditionsGroupContainer, {
    condition: condition,
    dataSeleniumInfo: dataSeleniumInfo,
    heading: heading,
    onGroupDelete: () => onConditionDelete(conditionPath),
    children: /*#__PURE__*/_jsx(EditorConditionRefinements, {
      inputUse: inputUse,
      condition: condition,
      filterFamily: PAGE_VIEW,
      onConditionChange: onFieldConditionValueChange,
      dateRefinement: dateRefinementCondition,
      numberRefinement: numberRefinementCondition
    })
  });
};
export default EditorPageViewRelatedConditionsGroup;